/* Progressive enhancement: menus and marquees keep usable HTML without JS. */
(() => {
  function init(root = document) {
    root.querySelectorAll('[data-cp-header]').forEach(header => {
      if (header.dataset.cpReady) return;
      header.dataset.cpReady = 'true';
      const wrapper = header.closest('.section-cp-header');
      const updateOffset = () => {
        if (!wrapper) return;
        const height = wrapper.getBoundingClientRect().height;
        const navHeight = header.querySelector('[data-cp-mobile-nav]')?.getBoundingClientRect().height || 0;
        document.documentElement.style.setProperty('--cp-header-offset', height + 'px');
        document.documentElement.style.setProperty('--cp-header-bar-height', Math.max(0, height - navHeight) + 'px');
      };
      updateOffset();
      if ('ResizeObserver' in window) {
        header.cpResizeObserver = new ResizeObserver(updateOffset);
        if (wrapper) header.cpResizeObserver.observe(wrapper);
      }
      const menus = [...header.querySelectorAll('[data-cp-mega]')];
      const mobileButton = header.querySelector('[data-cp-menu-toggle]');
      const mobileNav = header.querySelector('[data-cp-mobile-nav]');
      const setMenu = (menu, open) => {
        menu.classList.toggle('is-open', open);
        const panel = menu.querySelector('.cp-mega__panel');
        if (panel) panel.hidden = !open;
        menu.querySelectorAll(':scope > [aria-expanded]').forEach(control => control.setAttribute('aria-expanded', String(open)));
      };
      const closeMenus = except => menus.forEach(menu => { if (menu !== except) setMenu(menu, false); });
      menus.forEach(menu => {
        let timer;
        menu.addEventListener('pointerenter', () => {
          if (!matchMedia('(hover: hover) and (min-width: 1100px)').matches) return;
          clearTimeout(timer); closeMenus(menu); setMenu(menu, true);
        });
        menu.addEventListener('pointerleave', () => {
          if (!matchMedia('(hover: hover) and (min-width: 1100px)').matches) return;
          timer = setTimeout(() => { if (!menu.contains(document.activeElement)) setMenu(menu, false); }, 180);
        });
        menu.querySelector('.cp-mega__toggle')?.addEventListener('click', event => {
          event.stopPropagation();
          const open = !menu.classList.contains('is-open');
          closeMenus(menu); setMenu(menu, open);
        });
        menu.addEventListener('focusin', event => {
          // The toggle handles its own click; focusing it must not open then close the panel.
          if (event.target.closest('.cp-mega__toggle')) return;
          closeMenus(menu); setMenu(menu, true);
        });
        menu.addEventListener('focusout', () => setTimeout(() => {
          if (!menu.contains(document.activeElement)) setMenu(menu, false);
        }, 0));
      });
      mobileButton?.addEventListener('click', () => {
        const open = mobileNav.classList.toggle('is-open');
        mobileButton.setAttribute('aria-expanded', String(open));
      });
      header.addEventListener('keydown', event => {
        if (event.key !== 'Escape') return;
        const open = menus.find(menu => menu.classList.contains('is-open'));
        open?.querySelector('.cp-mega__trigger')?.focus(); closeMenus();
        if (mobileNav?.classList.contains('is-open')) {
          mobileNav.classList.remove('is-open'); mobileButton.setAttribute('aria-expanded','false'); mobileButton.focus();
        }
      });
      const outside = event => {
        if (!header.isConnected) { document.removeEventListener('click',outside); return; }
        if (!header.contains(event.target)) { closeMenus(); mobileNav?.classList.remove('is-open'); mobileButton?.setAttribute('aria-expanded','false'); }
      };
      document.addEventListener('click',outside);
      // Header is replaced when its section is edited in Shopify.
      const cart = document.querySelector('cart-drawer');
      const icon = header.querySelector('#cart-icon-bubble');
      // The deferred drawer script may not have upgraded the element yet.
      // Its constructor binds the initial icon; this also handles editor reloads.
      const bindCartIcon = () => {
        if (header.isConnected && cart && icon && !icon.hasAttribute('aria-haspopup') &&
            typeof cart.setHeaderCartIconAccessibility === 'function') {
          cart.setHeaderCartIconAccessibility();
        }
      };
      bindCartIcon();
      if (cart && !customElements.get('cart-drawer')) {
        customElements.whenDefined('cart-drawer').then(bindCartIcon);
      }
    });
    root.querySelectorAll('[data-cp-pause]').forEach(button => {
      if (button.dataset.cpReady) return;
      button.dataset.cpReady = 'true';
      button.addEventListener('click', () => {
        const paused = button.closest('.cp-marquee').classList.toggle('is-paused');
        button.setAttribute('aria-pressed', String(paused));
        button.setAttribute('aria-label', paused ? 'Resume scrolling' : 'Pause scrolling');
        button.textContent = paused ? '▶' : 'Ⅱ';
      });
    });
  }
  init();
  document.addEventListener('shopify:section:load',event => init(event.target));
  document.addEventListener('shopify:section:unload',event => {
    event.target.querySelector('[data-cp-header]')?.cpResizeObserver?.disconnect();
    document.body.classList.remove('overflow-hidden-drawer');
  });
})();
